import { useEffect, useState } from 'react';
import { Input } from 'antd';


export default function DdnField({value, onChange}) {

    const [inputValue, setInputValue] = useState(null)

    const isValidDate = (d) => {
        return d instanceof Date && !isNaN(d);
    }

    const dateToString = (_date) => {
        _date = new Date(_date)
        return ("0" + _date.getDate()).slice(-2) + "/" + ("0" + (_date.getMonth() + 1)).slice(-2) + "/" + _date.getFullYear()
    }

    const stringToDate = (s = "") => {
        const pattern = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/
        if (typeof s === "string" && s.match(pattern)) {
            //console.log(s.slice(6),s.slice(3,5),s.slice(0,2))
            const _date = new Date(s.slice(6), Number(s.slice(3, 5)) - 1, s.slice(0, 2))
            if (isValidDate(_date)) {
                return _date
            }
        }
        return null
    }

    const formater = (s = "") => {
        s = s.replace(/[^0-9\/]/g, '');

        if (Number(s[0]) > 3) {
            s = "0" + s
        }

        if (Number(s[3]) > 1) {
            s = s.slice(0, 3) + "0" + s.slice(3)
        }


        if (!inputValue || inputValue?.length < s.length) {
            if (s.length >= 2 && s[2] !== "/") {
                s = s.slice(0, 2) + "/" + s.slice(2)
            }
            if (s.length >= 5 && s[5] !== "/") {
                s = s.slice(0, 5) + "/" + s.slice(5)
            }

        }

        let _s = ""
        for (let i = 0; i < s.length; i++) {
            if (s[i] === "/" && i !== 2 && i !== 5) {
                continue
            }

            _s += s[i]
        }

        return _s.slice(0, 10)
    }

    useEffect(() => {
        //console.log("value changed",value,isValidDate(new Date(value)))
        if (value && isValidDate(new Date(value))) {
            const stringValue = dateToString(new Date(value))
            //console.log("string value",stringValue)

            if (stringValue !== inputValue) {
                setInputValue(stringValue)
            }
        }
    }, [value]);

    useEffect(() => {
        const _date = stringToDate(inputValue)
        if (_date && _date !== value && onChange) {
            onChange(_date)
        }
    }, [inputValue]);


    return (
        <Input
            placeholder={"20/05/2005"}
            value={inputValue}
            onChange={(e) => setInputValue(formater(e.target.value))}
            status={(inputValue?.length === 10 && !isValidDate(stringToDate(inputValue))) ? "error" : undefined}
        />
    )
}
